export default {
  /**
   * @description 网站标题
   */
  title: '年报',
  appKey:'dingiv4pvqgkz2tpvdek',
  /**
   * @description 请求超时时间，毫秒（默认2分钟）
   */
  timeout: 1200000
}
